/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-12 10:37:39
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-01-06 17:49:54
 * @FilePath: /unifyxp-v2-store-portal/src/types/common/linkType.ts
 */
import { Image } from './common';
import { EnumModuleType, EnumCarouselOptions } from './module';

export enum EnumLinkType {
  None = 'None',
  LinkLibrary = 'LinkLibrary',
  Product = 'Product',
  ProductCollection = 'ProductCollection',
  Cart = 'Cart',
  StorePage = 'StorePage',
  CampaignPage = 'CampaignPage',
  SysModule = 'SysModule',
}

export enum EnumLinkSource {
  External = 'External',
  Internal = 'Internal',
}

export interface ILinkModule {
  linkImage: Image | null;
  linkType: EnumLinkType;
  uuid: string | null;
}

export interface ILinkImage {
  linkModules: ILinkModule[];
  autoPlay: boolean;
  intervalTime: number;
  moduleType: EnumModuleType;
  moduleName: string;
  posterType: EnumCarouselOptions;
}

export enum EnumActionType {
  ProductDetail = 'ProductDetail',
  Cart = 'Cart',
}

export interface LinkModuleParam {
  contextUuid: string;
  contextType: string;
  keyword?: string;
  linkTypes: Array<string>;
  onlyShowVisibleProduct?: boolean;
}

export enum LinkModuleType {
  None = 'None',
  LinkLibrary = 'LinkLibrary',
  Product = 'Product',
  SysModule = 'SysModule',
  Collection = 'Collection',
  ContentPage = 'ContentPage',
  LegalPage = 'LegalPage',
  HomePage = 'HomePage',
  AllProducts = 'AllProducts',
  Cart = 'Cart',
  Profile = 'Profile',
  CustomerService = 'CustomerService',
  ShareMiniProgram = 'ShareMiniProgram',
}

export type LinkValue = {
  label: string;
  uuid: string;
  linkType: LinkModuleType;
  action: string;
  item?: any;
};
